<mat-card>
  <mat-card-title data-at-note-modal-title>
    <div class="header-wrapper">
      <span class="modal-title">
        {{ title | translate }}
      </span>

      <div class="close-btn" data-at-close-btn (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
    </div>
  </mat-card-title>
  <mat-card-content class="flex flex-col">
    <ng-container *ngIf="isImage(mediaUrl); then imagePanel; else videoPanel"></ng-container>

    <ng-template #imagePanel>
      <div class="image-wrapper">
        <img src="{{ mediaUrl }}" />
      </div>
    </ng-template>

    <ng-template #videoPanel>
      <video controls="controls">
        <source src="{{ mediaUrl }}" type="video/mp4" />
      </video>
    </ng-template>
    <div class="media-description">{{ description }}</div>
  </mat-card-content>
</mat-card>
